import React from 'react';

const WarningToast = ({ icon, heading, subheading }) => {
    return (
        <div className="planner-overlap-toast-content">
            <div className="planner-overlap-toast-icon" aria-hidden="true">{icon}</div>
            <div className="planner-overlap-toast-text">
                <div className="planner-overlap-toast-title">{heading}</div>
                <div className="planner-overlap-toast-message">{subheading}</div>
            </div>
        </div>
    );
};

export default WarningToast;